<div class="user-wrapper">
  <div class="user-detail-container">
    <div class="v-card">
      <div class="card list-header flex-row justify-content-between align-items-center pe-4 ps-2">
        <div class="header font-weight-700 fs-20 pt-1">
          <img class="back-button ps-1 pe-3 py-2" (click)="onBackButton()" src="assets/img/back-blue.svg" alt="">
          {{ 'MAIN.SESSIONS.SESSION_DETAILS.TITLE' | translate }}
        </div>
        @if ((sessionExportEnabled || wipeSessionDataBtnEnabled)) {
          <div class="d-flex flex-row">
            <div data-placement="bottom" [dynamicTooltip]="'MAIN.SESSIONS.SESSION_DETAILS.SESSION_DATA_WIPED' | translate"
              [tooltipDisabled]="!(webdavEnabled || session.session_files_deleted)">
              @if (wipeSessionDataBtnEnabled) {
                <button class="v-btn btn btn-danger vsight-button me-2"
                  (click)="onWipeSessionData()" [disabled]="webdavEnabled || session.session_files_deleted">
                  {{ 'MAIN.SESSIONS.SESSION_DETAILS.WIPE_SESSION_DATA' | translate }}
                </button>
              }
            </div>
            @if (sessionExportEnabled && !webdavEnabled && !session.session_files_deleted) {
              <button
                class="v-btn btn btn-primary vsight-button" (click)="onGetExport()">
                {{ 'MAIN.SESSIONS.SESSION_DETAILS.GET_SESSION_EXPORT' | translate }}
              </button>
            }
          </div>
        }
      </div>
      <div class="card-body row">
        <div class="col-7" style="padding-left: 45px;padding-right: 45px;">
          <div class="row">
            @if (userSessions) {
              <div class="col-12 mt-2 mb-3"><span class="fs-16 font-weight-600">{{ session.room.name
              }}</span></div>
            }
            @if (!userSessions) {
              <div class="col-12 mt-2 mb-3"><span class="fs-16 font-weight-600">{{ session.room_id |
              roomName | async }}</span></div>
            }
            <div class="col-12 mt-3 fs-14 text-dark-grey font-weight-600 row">
              <div class="key col-2">{{ 'MAIN.SESSIONS.SESSION_DETAILS.DATE' | translate }} </div>
              <div class="value fs-14 text-dark-grey font-weight-600 col-10">{{ session.create_time |
              utcCalcAccount:true | async }}</div>
            </div>
            <div class="col-12 mt-3 fs-14 text-dark-grey font-weight-600 row">
              <div class="key col-2">{{ 'MAIN.SESSIONS.SESSION_DETAILS.DURATION' | translate }}</div>
              <div class="value fs-14 text-dark-grey font-weight-600 col-10">{{ session | sessionDuration }}</div>
            </div>

            <!-- session.users and session.guest_users are array -->
            @if (userSessions) {
              <div class="col my-3">
                <div class="d-flex flex-row">
                  <div class="key fs-14 text-dark-grey font-weight-600 col-2">{{
                  'MAIN.SESSIONS.SESSION_DETAILS.PARTICIPANTS' | translate }} </div>
                  <div class="participants">
                    @for (suser of session.users; track suser) {
                      <div class="d-flex">
                        <div class="me-3 fs-14 text-dark-grey"> {{ suser.name }} </div>
                        @for (user of users; track user) {
                          <div>
                            @if (!session.user_durations && user.id === suser.id) {
                              <div class="d-flex flex-column value ml-2"
                                >
                                <div> <a class="email-text core-blue fs-14" href="mailto:{{ user.email }}">{{ user.email }}</a>
                              </div>
                            </div>
                          }
                          @for (duration of (session.user_durations | keyvalue); track duration) {
                            <div>
                              @if (user.id === suser.id && duration.key === user.id) {
                                <div class="d-flex value ml-2">
                                  <div class="ml-auto pl-3 me-3 fs-14 text-dark-grey">
                                    {{ duration.value | durationFormat: 'ms':'hhmmss' }}
                                  </div>
                                </div>
                              }
                              @if (user.id === suser.id && duration.key === user.id) {
                                <div class="d-flex value ml-2 mb-3">
                                  <a class="email-text core-blue fs-14" href="mailto:{{ user.email }}">{{ user.email }}</a>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  @if (session.guest_users && session.guest_users.length > 0) {
                    <div>
                      @for (guest of session.guest_users; track guest) {
                        <span>
                          <!-- When user_durations exists -->
                          @for (duration of (session.user_durations | keyvalue); track duration) {
                            <span>
                              @if (duration.key === guest.id) {
                                <div class="d-flex value ml-2 mb-3 fs-14 text-dark-grey">
                                  {{ guest.name }} &nbsp; <span class="fs-14 text-dark-grey me-2">{{
                                'MAIN.SESSIONS.SESSION_DETAILS.GUEST' | translate }}</span>
                                <div class="ml-auto pl-3">{{ duration.value | durationFormat: 'ms':'hhmmss' }}</div>
                              </div>
                            }
                          </span>
                        }
                        <!-- When user_durations doesn't exist -->
                        @if (!session.user_durations) {
                          <div class="d-flex value ml-2 mb-3 fs-14 text-dark-grey">
                            {{ guest.name }} &nbsp; <span class="fs-14 text-dark-grey me-2">{{
                          'MAIN.SESSIONS.SESSION_DETAILS.GUEST' | translate }}</span>
                        </div>
                      }
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }

      <!-- session.users and session.guest_users are objects -->
      @if (!userSessions) {
        <div class="col my-3">
          <div class="d-flex flex-row">
            <div class="key fs-14 text-dark-grey font-weight-600 col-2">{{
            'MAIN.SESSIONS.SESSION_DETAILS.PARTICIPANTS' | translate }} </div>
            <div class="participants">
              @for (name of (session.users | getIds | filterGuests:session.guest_users | userNames | async); track name) {
                <div
                  class="d-flex">
                  <div class="me-3 fs-14 text-dark-grey"> {{ name }} </div>
                  @for (user of users; track user) {
                    <div>
                      @if (!session.user_durations && user.name === name) {
                        <div class="d-flex flex-column value ml-2">
                          <div> <a class="email-text core-blue fs-14" href="mailto:{{ user.email }}">{{ user.email }}</a>
                        </div>
                      </div>
                    }
                    @for (duration of (session.user_durations | keyvalue); track duration) {
                      <div>
                        @if (user.name === name && duration.key === user.id) {
                          <div class="d-flex value ml-2">
                            <div class="ml-auto pl-3 me-3 fs-14 text-dark-grey">
                              {{ duration.value | durationFormat: 'ms':'hhmmss' }}
                            </div>
                          </div>
                        }
                        @if (user.name === name && duration.key === user.id) {
                          <div class="d-flex value ml-2 mb-3">
                            <a class="email-text core-blue fs-14" href="mailto:{{ user.email }}">{{ user.email }}</a>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @for (guest of (session.guest_users | objectToArray); track guest) {
              <span>
                @for (duration of (session.user_durations | keyvalue); track duration) {
                  <span>
                    @if (duration.key === guest.id) {
                      <div class="d-flex value ml-2 mb-3 fs-14 text-dark-grey">
                        {{ guest.name }} &nbsp; <span class="fs-14 text-dark-grey me-2">{{
                      'MAIN.SESSIONS.SESSION_DETAILS.GUEST' | translate }}</span>
                      <div class="ml-auto pl-3">{{ duration.value | durationFormat: 'ms':'hhmmss' }}</div>
                    </div>
                  }
                </span>
              }
            </span>
          }
        </div>
      </div>
    </div>
  }

</div>

<div style="border-bottom: solid 1px #ececec; padding-top: 30px;" class="w-100"></div>

@if (!webdavEnabled && !session.session_files_deleted) {
  @if (!webdavEnabled && !session.session_files_deleted) {
    <app-archives
    [room_id]="session.room ? session.room.id : session.room_id" [session_id]="session.id"></app-archives>
  }
  <div style="border-bottom: solid 1px #ececec; padding-top: 30px;" class="w-100"></div>
}

@if (!webdavEnabled && !session.session_files_deleted) {
  <div class="top-gap-30">
    <div class="">
      <div class="d-flex justify-content-between align-items-center">
        <span class="fs-14 font-weight-700">{{ 'MAIN.SESSIONS.SESSION_DETAILS.CHAT' | translate }}</span>
      </div>
      <div class="card-body">
        <app-session-chat [session]="session"></app-session-chat>
      </div>
    </div>
  </div>
}
</div>

@if (!webdavEnabled && !session.session_files_deleted) {
  <div class="col-5" style="padding-right: 60px;">
    <div class="files-chat">
      <div class="mb-3">
        <div class="file-area">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="fs-14 font-weight-700">{{ 'MAIN.SESSIONS.SESSION_DETAILS.FILES' | translate }}</span>
            <div>
              @if (!showDownloadButton) {
                <button
                  class="v-btn btn btn-primary-outline vsight-button-outline-primary" (click)="toggleSelection()">{{
                'MAIN.LOBBY.SESSIONS.SESSION_FILES.MULTIPLE_SELECTION' | translate | uppercase }}</button>
              }
              @if (showDownloadButton) {
                <button
                  class="v-btn btn btn-primary-outline vsight-button-outline-secondary me-3"
                (click)="toggleSelection()">{{ 'MODALS.ALERT.CANCEL' | translate }}</button>
              }
              @if (showDownloadButton) {
                <button class="v-btn btn btn-primary vsight-button fs-13"
                  (click)="onDownloadStarted()">{{ 'MAIN.LOBBY.SESSIONS.SESSION_FILES.DOWNLOAD' | translate |
                uppercase }}</button>
              }
            </div>
          </div>
          <div>
            @if (session) {
              <app-session-file [session]="session" [session_id]="session.id"
                [showCheckboxes]="showCheckboxes" [downloadSelectedFiles]="downloadSelectedFiles">
              </app-session-file>
            }
          </div>
        </div>
      </div>
    </div>
    @if (ticketAvailable) {
      <div class="files-chat ticket-box">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="fs-14 font-weight-700">{{ 'MAIN.CONTENT.TICKETS.TITLE' | translate }}</span>
        </div>
        <div>
          @if (!attachedTicketId) {
            <button class="v-btn btn btn-primary-outline vsight-button-outline-primary"
              (click)="onAttachToTicket()">
              {{ 'MAIN.SESSIONS.SESSION_DETAILS.ATTACH_TO_TICKET' | translate }}
            </button>
          }
          @if (attachedTicket) {
            <div class="mt-3 fs-14 text-dark-grey d-flex align-items-center">
              <span class="key">{{ 'MAIN.SESSIONS.SESSION_DETAILS.ATTACHED_TICKET' | translate }}: </span>
              <button type="button" class="values ticket-link" (click)="onAttachedTicketDetails()">
                {{ attachedTicket.title }}
              </button>
              <img src="assets/img/close-circle.svg" alt="" class="detach-ticket-icon ms-2"
                (click)="onDetachFromTicket()" title="{{ 'MAIN.CONTENT.TICKETS.DETACH_SESSION' | translate }}">
            </div>
          }
          @if (attachedTicketId) {
            <button
              class="v-btn btn btn-primary-outline vsight-button-outline-primary mt-3" (click)="onAttachToTicket()">
              {{ 'MAIN.SESSIONS.SESSION_DETAILS.CHANGE_TICKET' | translate }}
            </button>
          }
        </div>
      </div>
    }
    @if (novaAvailable) {
      <div class="files-chat ticket-box">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="fs-14 font-weight-700">Nova</span>
        </div>
        <div>
          <!-- Not added / deleted / initial loading / processing / error states -->
          @if (novaStatus !== 'ready') {
                <button class="v-btn btn vsight-button-outline-primary nova-btn" [ngClass]="{
                    'btn-primary-outline': novaStatus !== 'error',
                    'nova-btn-error': novaStatus === 'error'
                  }" [disabled]="novaButtonDisabled" (click)="onAddNova()">
              @if (novaIsProcessing || novaIsRequesting || novaInitialLoading) {
                <span
                class="spinner-border spinner-border-sm me-2"></span>
              }
              {{ novaButtonLabel }}
            </button>
          }
          <!-- Ready state — success card with remove option -->
          @if (novaStatus === 'ready') {
            <div class="nova-ready-card">
              <div class="nova-ready-header">
                <div class="nova-ready-badge">
                  <span class="nova-check-icon">✓</span>
                  <span>Added to Nova</span>
                </div>
                @if (!novaConfirmRemove) {
                  <button class="nova-remove-btn" (click)="novaConfirmRemove = true"
                    title="Remove from Nova">
                    <img src="assets/img/close-circle.svg" alt="" class="nova-remove-icon">
                  </button>
                }
              </div>
              <!-- Inline confirmation -->
              @if (novaConfirmRemove) {
                <div class="nova-confirm-bar">
                  <span class="nova-confirm-text">Remove this session from Nova?</span>
                  <div class="nova-confirm-actions">
                    <button class="nova-confirm-yes" [disabled]="novaIsDeleting" (click)="onRemoveFromNova()">
                      @if (novaIsDeleting) {
                        <span class="spinner-border spinner-border-sm me-1"></span>
                      }
                      {{ novaIsDeleting ? 'Removing...' : 'Remove' }}
                    </button>
                    <button class="nova-confirm-no" [disabled]="novaIsDeleting"
                    (click)="novaConfirmRemove = false">Cancel</button>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
</div>
</div>
<!--
<div class="card mt-4" *ngIf="sessionExportEnabled && !webdavEnabled && !session.session_files_deleted">
  <div class="card-header d-flex justify-content-between align-items-center">
    <span class="card-header-title">{{ 'MAIN.SESSIONS.SESSION_DETAILS.SESSION_EXPORT.TITLE' | translate }}</span>
  </div>
  <div class="card-body py-4 px-4 px-md-5">
    <div class="recipients-message mb-2">{{ 'MAIN.SESSIONS.SESSION_DETAILS.SESSION_EXPORT.MESSAGE' | translate:('design' | env) }}</div>
    <app-email-chips #tagInput [(ngModel)]="exportRecipients" [placeholder]="emailPholder" [secondaryPlaceholder]="emailSecPholder" [validators]="[validMailValidator]" [errorMessages]="invalidEmailError" [addOnBlur]="true"></app-email-chips>

    <div class="recipients-warning-text mt-2">{{ 'MAIN.SESSIONS.SESSION_DETAILS.SESSION_EXPORT.WARNING' | translate }}</div>

    <button class="btn btn-info btn-block mt-2" [ngStyle]="{'cursor': exportRecipients.length !== 0 ? 'pointer' : 'default'}" [fakeDisabled]="exportRecipients.length === 0" (enabledClick)="onSessionExport()">{{ 'MAIN.SESSIONS.SESSION_DETAILS.SESSION_EXPORT.SEND' | translate }}</button>
  </div>
</div>
-->


</div>
</div>

<ng-template #pickTicketTemplate let-dataModel="dataModel" let-callbacks="callbacks">
  <div class="modal-dialog modal-xl modal-dialog-centered ticket-picker-dialog" role="document">
    <div class="modal-content">
      <div class="v-card ticket-picker-modal">
        <div class="modal-header d-flex align-items-center justify-content-between">
          <div class="modal-title font-weight-600">{{ 'MAIN.SESSIONS.SESSION_DETAILS.ATTACH_SESSION_TO_TICKET' |
          translate }}</div>
          <div class="cursor-pointer" (click)="callbacks.close()">
            <img src="assets/img/close_white.svg" alt="">
          </div>
        </div>
        <div class="card-body">
          <div class="m-body ticket-list-wrapper">
            @if (dataModel.loading) {
              <div class="ticket-list-loading">
                <div class="loader loader-sm la-dark">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            }

            @if (!dataModel.loading) {
              <div class="user-table-header d-flex align-items-center">
                <div class="col-1 fs-14 font-weight-400 text-dark-grey">#</div>
                <div class="col-5 fs-14 font-weight-400 text-dark-grey">{{ 'MAIN.CONTENT.TICKETS.TICKET_TITLE' |
                translate }}</div>
                <div class="col-3 fs-14 font-weight-400 text-dark-grey">{{ 'MAIN.CONTENT.TICKETS.CREATED_BY' | translate
                }}</div>
                <div class="col-2 fs-14 font-weight-400 text-dark-grey">{{ 'MAIN.CONTENT.TICKETS.CREATED_ON' | translate
                }}</div>
                <div class="col-1 fs-14 font-weight-400 text-dark-grey">{{ 'MAIN.CONTENT.TICKETS.STATUS' | translate }}
                </div>
              </div>
              @if (dataModel.tickets.length === 0) {
                <div class="ticket-list-empty">
                  {{ 'MAIN.CONTENT.TICKETS.NO_TICKETS' | translate }}
                </div>
              }
              @for (t of dataModel.tickets; track t; let i = $index) {
                <div
                  class="workflow-card d-flex align-items-center cursor-pointer"
                  [ngClass]="{'selected': selectedTicket === t.id}" (click)="onTicketClicked(t.id);">
                  <div class="col-1 fs-14 font-weight-400 text-light-black">{{ i+1 }}</div>
                  <div class="col-5 fs-15 font-weight-700">{{ t.title }}</div>
                  <div class="col-3 fs-14 font-weight-400 text-light-black">{{ getUsersName(t.creator) }}</div>
                  <div class="col-2 fs-14 font-weight-400 text-light-black">{{ t.create_time | utcCalcAccount | async }}
                  </div>
                  <div class="col-1 fs-13 font-weight-600">
                    <span [ngClass]="'status-pill ' + t.status">{{ 'MAIN.CONTENT.TICKETS.STATUS_' + (t.status | uppercase)
                    | translate }}</span>
                  </div>
                </div>
              }
            }
          </div>
          <div class="m-footer d-flex justify-content-center">
            <button type="button"
              class="v-btn vsight-button left btn vsight-button-outline-secondary btn-outline-secondary"
              (click)="callbacks.close()">
              {{ 'MAIN.SESSIONS.SESSION_DETAILS.CLOSE' | translate }}
            </button>
            <button type="button" class="v-btn vsight-button btn btn-primary"
              [disabled]="!selectedTicket || selectedTicket === dataModel.initialTicketId"
              (click)="selectedTicket && selectedTicket !== dataModel.initialTicketId ? callbacks.attach() : null">
              {{ 'MAIN.SESSIONS.SESSION_DETAILS.ATTACH' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>